import { Check, Prohibit } from "@phosphor-icons/react";

export function ProgressStepper({ progress, compact = false }) {
  if (!progress?.steps?.length) return null;
  const { steps, halted, pct } = progress;
  return (
    <div data-testid="progress-stepper">
      {halted && (
        <div className="flex items-center gap-2 text-xs font-medium text-red-600 dark:text-red-400 mb-3" data-testid="progress-halted">
          <Prohibit size={14} weight="bold" /> {halted}
        </div>
      )}
      <ol className={`flex ${compact ? "gap-1" : "gap-2"} items-start`}>
        {steps.map((s, i) => {
          const done = s.state === "done";
          const cur = s.state === "current";
          return (
            <li key={s.key} className="flex-1 min-w-0" data-testid={`step-${s.key}`} data-state={s.state}>
              <div className="flex items-center">
                <div className={`h-6 w-6 shrink-0 rounded-full flex items-center justify-center text-[10px] font-bold border-2 transition-colors
                  ${done ? "bg-emerald-500 border-emerald-500 text-white" : cur ? (halted ? "border-red-500 text-red-600" : "border-primary text-primary bg-primary/10 animate-pulse") : "border-border text-muted-foreground bg-card"}`}>
                  {done ? <Check size={12} weight="bold" /> : i + 1}
                </div>
                {i < steps.length - 1 && <div className={`h-0.5 flex-1 mx-1 ${done ? "bg-emerald-500" : "bg-border"}`} />}
              </div>
              {!compact && (
                <p className={`mt-1.5 text-[10px] leading-tight pr-1 ${cur ? "font-semibold text-foreground" : done ? "text-emerald-700 dark:text-emerald-400" : "text-muted-foreground"}`}>{s.label}</p>
              )}
            </li>
          );
        })}
      </ol>
      {compact && <p className="text-[11px] mt-1.5 text-muted-foreground">{progress.current_label} · {pct}%</p>}
    </div>
  );
}
